import { getStatusClass } from "../../common/helper/transaction-status.component.js";
import useNavigation from "../../../hooks/useNavigation.js";

export const pendingColumns = (
  expanded,
  changeStatus,
  approveAgent,
  deleteAgent
) => {
  const { navigateTo } = useNavigation();

  return [
    {
      name: "Full Name",
      selector: (row) => row.full_name,
      sortable: true,
      // style: row => ({ minWidth: '100px' }),
    },
    {
      name: "Agent Id",
      selector: (row) => row.agent_id,
      sortable: true,
      // style: row => ({ minWidth: '50px' }),
    },
    // {
    //   name: 'Phone',
    //   selector: row => row.mobile_number,
    //   sortable: true,
    //   //style: row => ({ minWidth: '100px' }),
    // },
    {
      name: "Email",
      selector: (row) => (
        <div>
          <p className="mb-1">{row.email_address}</p>
          <p className="mb-0">{row.mobile_number}</p>
        </div>
      ),
      sortable: true,
      // style: row => ({ minWidth: '100px' }),
    },
    {
      name: "Wallet",
      selector: (row) =>
        row.balances ? "₹" + row.balances.pay_in_balance : "₹0",
      sortable: true,
      //style: row => ({ minWidth: '50px' }),
    },
    {
      name: "Holdings",
      selector: (row) =>
        row.balances ? "₹" + row.balances.blocked_amount : "₹0",
      sortable: true,
      // style: row => ({ minWidth: '50px' }),
    },

    {
      name: "Status",
      sortable: true,
      button: true,
      selector: (row) => row.status,

      cell: (row) => (
        <>
          <div
            className={`badge badge-pill ${getStatusClass(
              row.status
            )} font-size-12`}
            style={{
              backgroundColor:
                row.user_id && !!expanded[row.user_id] ? "white" : "",
            }}
          >
            {row.status}
          </div>
        </>
      ),
      // cell: row =>
      //  <>
      //     <span className="mgh">
      //       <img style={{width: '15px'}} src="https://cdn-icons-png.flaticon.com/512/1011/1011500.png" />
      //     </span>
      //     </>
    },
    {
      name: "Email Verified",
      button: true,
      style: (row) => ({ justifyContent: "flex-start" }),
      cell: (row) => (
        <>
          {row.is_verification_pending && (
            <span
              className="badge badge-pill badge-soft-pending font-size-12"
              style={{
                backgroundColor:
                  row.user_id && !!expanded[row.user_id] ? "white" : "",
              }}
            >
              Pending
            </span>
          )}

          {!row.is_verification_pending && (
            <span
              className="badge badge-pill badge-soft-success font-size-12"
              style={{
                backgroundColor:
                  row.user_id && !!expanded[row.user_id] ? "white" : "",
              }}
            >
              Completed
            </span>
          )}
        </>
      ),
    },
    {
      name: "Actions",
      button: true,
      //style: row => ({ minWidth: '150px' }),
      cell: (row) => (
        <>
          <a
            className={`fview tooltip ${
              row.status === "Rejected" ? "disable" : ""
            }`}
            style={{ cursor: "pointer" }}
            onClick={() => navigateTo("view", "view-agent", row.user_id)}
          >
            <i
              className={`fa ${
                row.status === "Rejected" ? "fa-eye disable" : "fa-eye"
              }`}
              style={{
                color:
                  row.user_id && !!expanded[row.user_id] ? "white" : "black",
              }}
            />
            <span className="tooltiptext">View</span>
          </a>
          <a
            className={`flock tooltip ${
              row.status === "Initiated" || row.status === "Rejected"
                ? "disable"
                : ""
            }`}
            onClick={() => changeStatus(row)}
            style={{ cursor: "pointer" }}
          >
            <i
              className={`fa ${
                row.status === "Initiated" || row.status === "Rejected"
                  ? "fa-lock disable"
                  : row.status === "Suspended"
                  ? "fa-unlock"
                  : "fa-lock"
              }`}
              style={{
                color:
                  row.user_id && !!expanded[row.user_id] ? "white" : "black",
              }}
            />
            <span className="tooltiptext">
              {" "}
              <>
                {row.status !== "Active"
                  ? "Lock"
                  : "UnLock" // Or whatever you want to show if the status is 'Active'
                }
              </>
            </span>
          </a>
          {row.status !== "Initiated" && (
            <a
              className={`fedit tooltip ${
                row.status === "Rejected" || row.status === "Suspended"
                  ? "disable"
                  : ""
              }`}
              style={{ cursor: "pointer" }}
              onClick={() =>
                navigateTo(
                  "EditAgent",
                  "edit-agent",
                  row.user_id,
                  row.customer_id
                )
              }
            >
              <i
                className={`fa ${
                  row.status === "Rejected" || row.status === "Suspended"
                    ? "fa-edit disable"
                    : "fa-edit"
                }`}
                style={{
                  color:
                    row.user_id && !!expanded[row.user_id] ? "white" : "black",
                }}
              />
              <span className="tooltiptext">Edit</span>
            </a>
          )}
          {row.status !== "Active" &&
            row.status !== "Rejected" &&
            row.status !== "Suspended" && (
              <a
                className={`fedit tooltip ${
                  row.status === "Active" || row.status === "Rejected"
                    ? "disable"
                    : ""
                }`}
                onClick={() => approveAgent(row)}
                style={{ cursor: "pointer" }}
              >
                <i
                  className={`fa ${
                    row.status === "Active" ||
                    row.status === "Rejected" ||
                    row.is_verification_pending
                      ? "fa-check-circle disable"
                      : "fa-check-circle"
                  }`}
                  style={{
                    color:
                      row.user_id && !!expanded[row.user_id]
                        ? "white"
                        : "black",
                  }}
                />
                <span className="tooltiptext">Approve</span>
              </a>
            )}
          <a
            style={{ cursor: "pointer" }}
            onClick={() => deleteAgent(row)}
            className={`ftrash tooltip ${
              row.status === "Initiated" || row.status === "Rejected"
                ? "disable"
                : ""
            }`}
            href="#"
          >
            <i
              className={`fa ${
                row.status === "Initiated" || row.status === "Rejected"
                  ? "fa-trash disable"
                  : "fa-trash"
              }`}
              style={{
                color:
                  row.user_id && !!expanded[row.user_id] ? "white" : "black",
              }}
            />
            <span className="tooltiptext">Delete</span>
          </a>
          <a
            className="fell tooltip"
            href="#"
            style={{ "padding-right": "25px", cursor: "pointer" }}
          >
            <i
              className="fa fa-ellipsis-v"
              style={{
                color:
                  row.user_id && !!expanded[row.user_id] ? "white" : "black",
              }}
              aria-hidden="true"
            />
            <span className="tooltiptext">More</span>
          </a>
        </>
      ),
    },
  ];
};
